//
// ChatVehicle - Component for displaying vehicle description form data in chat
// Shows vehicle details including type, brand, color, license plate, and notes
//
//  const msg = {
//   qstnId: 'vehicleDescr',
//   type: 'car',
//   subType: 'hatchback',
//   brand: 'Bmw',
//   model: '118d',
//   color: 'lightGrey',
//   country: 'de',
//   licence: '1234-JV',
//   note: 'kiki',
//   qstnTxt: 'du contrevenant',
//   crUid: 3,
//   crAppId: 2,
//   msgType: 'form',
//   msgCdatim1: '2020-10-21 18:01:39.2',
//   msgIdAnswer: null,
//   msgId: 23,
//   msgUid: 6,
//   crUidAdd: 3,
//   id: 3,
// };

import PropTypes from 'prop-types';

import {
  vehicleCountries,
  colors,
} from '../../../../utils';
import {
  Row,
  Column,
} from '../../../display';
import {
  VehicleIcon,
  LicencePlate,
} from '../../../graphics';

import { MessageText } from './components';

function ChatVehicle({
  translate,
  message,
}) {
  const {
    qstnId, // 'vehicleDescr',
    vehicle,
    note, // 'kiki',
    qstnTxt, // 'du contrevenant',
    unknown,
  } = message;
  const {
    type, // 'car',
    subType, // 'hatchback',
    brand, // 'Bmw',
    model, // '118d',
    color, // 'lightGrey',
    country, // 'de',
    licence, // '1234-JV',
    company, //
  } = vehicle ?? {};
  const content = [];

  if (unknown) {
    const unknownMessage = `${translate(qstnId, 'questionnaireTitles')}${(qstnTxt)
      ? ` ${qstnTxt}: `
      : ': '}${translate('iDontKnow')}`;

    return (
      <div className="w-full">
        <MessageText
          message={unknownMessage}
          author={null}
          italic
          bold
        />
      </div>
    );
  }

  if (type) {
    const typeDescription = (subType)
      ? `${translate(type, 'vehicles')}, ${translate(subType, 'vehicles')}`
      : `${translate(type, 'vehicles')}`;

    content.push(
      <Row
        key="type"
        className="mb-2"
        start
        crossStart
      >
        <VehicleIcon
          description={typeDescription}
          type={type}
          subType={subType}
        />
        <p className="ml-2.5">{typeDescription}</p>
      </Row>,
    );
  }

  let brandDescription;
  if (brand) brandDescription = brand;
  if (model) {
    if (brand) brandDescription += `, ${model}.`;
    else brandDescription = `${translate('model', 'vehicles')}: ${model}.`;
  }
  if (brand || model || color) {
    content.push(
      <Row
        key="brandColor"
        className="mb-2"
        start
        crossStart
      >
        {(brandDescription) || null}
        {(color)
          ? (
              <Row className="ml-4" start crossStart>
                <div
                  className="w-6 h-6 mr-1.5"
                  style={{
                    backgroundColor: colors[color],
                  }}
                />

                <div className="flex-1 flex items-center justify-start">
                  {translate(color, 'colors')}
                </div>
              </Row>
            )
          : null}
      </Row>,
    );
  }

  if (country || licence) {
    content.push(
      <Row
        key="ctry"
        className="mb-3"
        start
        crossStart
      >
        {(licence)
          ? (
              <LicencePlate
                country={country}
                licence={licence}
              />
            )
          : null}
        {(country)
          ? (
              <Row className="ml-4" start crossStart>
                <div className="w-7 h-6 border-2 border-black rounded-full bg-white flex items-center justify-center">
                  <b>{vehicleCountries[country]}</b>
                </div>

                <div className="ml-2.5">
                  {translate(country, 'countries')}
                </div>
              </Row>
            )
          : null}
      </Row>,
    );
  }

  if (company) {
    content.push(
      <Row
        key="company"
        className="mb-2"
        start
        crossStart
      >
        {`${translate('companyOrLogo', 'vehicles')}: ${company}.`}
      </Row>,
    );
  }

  return (
    <div className="w-full">
      <MessageText
        message={`${translate(qstnId, 'questionnaireTitles')}${(qstnTxt) ? ` ${qstnTxt}:` : ':'}`}
        author={null}
        italic
        bold
      />

      <Column className="relative">
        {content}
      </Column>

      {(note)
        ? (
            <div className="max-w-full break-words whitespace-normal p-2">
              <div className="bg-pxBgMuted p-2 rounded-md border shadow-sm">
                <u>{`${translate('notes')}:`}</u>
                <br />
                <p className="pl-2.5 mt-1 mb-0">
                  {note}
                </p>
              </div>
            </div>
          )
        : null}
    </div>
  );
}

ChatVehicle.propTypes = {
  translate: PropTypes.func.isRequired,
  message: PropTypes.shape({
    qstnId: PropTypes.string.isRequired,
    vehicle: PropTypes.shape({
      type: PropTypes.string,
      subType: PropTypes.string,
      brand: PropTypes.string,
      model: PropTypes.string,
      color: PropTypes.string,
      country: PropTypes.string,
      licence: PropTypes.string,
      company: PropTypes.string,
    }),
    note: PropTypes.string,
    qstnTxt: PropTypes.string,
    unknown: PropTypes.bool,
  }).isRequired,
};

export default ChatVehicle;
